module.exports = __webpack_public_path__ + "img/logofeebmg.166d2904.svg";